import {
    Directive,
    Input,
    OnInit,
    TemplateRef,
    ViewContainerRef,
} from '@angular/core';

import { AuthService } from '../core';
import { take } from 'rxjs/operators';

@Directive({ selector: '[solisUserGroup]' })
export class UserGroupDirective implements OnInit {
    constructor(
        private templateRef: TemplateRef<any>,
        private authService: AuthService,
        private viewContainer: ViewContainerRef,
    ) {}

    condition: string;

    ngOnInit() {
        this.authService.userGroup$.pipe(take(1)).subscribe(userGroup => {
            if (userGroup === this.condition) {
                this.viewContainer.createEmbeddedView(this.templateRef);
            } else {
                this.viewContainer.clear();
            }
        });
    }

    @Input()
    set solisUserGroup(condition: string) {
        this.condition = condition;
    }
}
